import { FC, useCallback, useEffect, useState } from 'react';

import { ITitleWithSort } from '@pra-vendas-themes/interfaces/ITitleWithSort';
import FormFieldSelect from '@pra-vendas-themes/default/components/Form/FormFieldSelect';

import {
  Wrapper,
  Title,
  Subtitle,
  SupplementaryTitle,
  WrapperRight,
  WrapperLeft,
} from './styles';

const sortOptions = [
  { name: 'Mais recentes', value: undefined },
  { name: 'Menor preço', value: 'price-ascending' },
  { name: 'Maior preço', value: 'price-descending' },
  { name: 'A - Z', value: 'name-ascending' },
  { name: 'Z - A', value: 'name-descending' },
];

const TitleWithSort: FC<ITitleWithSort> = ({
  supplementaryTitle,
  title,
  subtitle,
  onChangeSortBy,
}) => {
  const [sortValue, setSortValue] = useState(sortOptions[0]);
  const _subtitle = subtitle?.replace(/(\d+)/g, '<strong>$1</strong>');

  const handleChangeSort = useCallback((e: any) => {
    setSortValue(e.target.value);
  }, []);

  useEffect(() => {
    if (sortValue) {
      onChangeSortBy?.(sortValue.value);
    }
  }, [onChangeSortBy, sortValue]);

  return (
    <Wrapper>
      <WrapperLeft>
        {supplementaryTitle && (
          <SupplementaryTitle>{supplementaryTitle}</SupplementaryTitle>
        )}
        <Title>{title}</Title>
      </WrapperLeft>
      <WrapperRight>
        {_subtitle && (
          <Subtitle dangerouslySetInnerHTML={{ __html: _subtitle }} />
        )}
        {onChangeSortBy && (
          <FormFieldSelect
            name="sort"
            options={sortOptions}
            value={sortValue}
            onChange={handleChangeSort}
            getOptionLabel={(opt) => opt?.name}
            getValueLabel={(opt) => opt?.name}
          />
        )}
      </WrapperRight>
    </Wrapper>
  );
};

export default TitleWithSort;
